// extracted by mini-css-extract-plugin
export default {"engBg":"styles_engBg__mZIw+","containerBig":"styles_containerBig__snuQB","engBgBottom":"styles_engBgBottom__xOyEB"};